// extracted by mini-css-extract-plugin
module.exports = {"progressStats":"progressStats_1HyOytUE","controls":"controls_1gvAbH83"};